import {
  TranslationPermissionMessages,
  PermissionMessages
} from "../interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationPermissionMessages = {
  [PermissionMessages.linkContractToUserText]: "Link contract to user",
  [PermissionMessages.linkContractsSelectedText]: "Link contracts selected",
  [PermissionMessages.permissionsForText]: "Permissions for"
};
